import * as React from "react";
import { CheckIcon, CloseIcon } from "../icons";

export default ({ value }: { value: boolean }) => (value ? <CheckIcon /> : <CloseIcon />);
